document.addEventListener('DOMContentLoaded', function () {
  // Select the subscribe buttons by their unique classes
  var monthlyBtn = document.querySelector('.gY1hu022P-');
  var yearlyBtn  = document.querySelector('.gqgRJaKVNQ');
  var dailyBtn   = document.querySelector('.g8zz9yaGfp');

  // Function to generate current timestamp in UTC formatted as "YYYY-MM-DD HH:MM:SS"
  function getCurrentTimestamp() {
    var now     = new Date();
    var year    = now.getUTCFullYear();
    var month   = ("0" + (now.getUTCMonth() + 1)).slice(-2);
    var day     = ("0" + now.getUTCDate()).slice(-2);
    var hours   = ("0" + now.getUTCHours()).slice(-2);
    var minutes = ("0" + now.getUTCMinutes()).slice(-2);
    var seconds = ("0" + now.getUTCSeconds()).slice(-2);
    return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
  }

  // Define plan configurations for monthly and yearly subscriptions
  var monthlyConfig = {
    mainamount:             "19.99",  // Monthly price
    subscriptionfrequency:  "1",      // 1 month per cycle
    subscriptionunit:       "MONTH",  // Must be "DAY" or "MONTH"
    subscriptionfinalnumber: "0"      // 0 = indefinite
  };

  var yearlyConfig = {
    mainamount:             "149.99", // Yearly price
    subscriptionfrequency:  "12",     // 12 months per cycle (1 year)
    subscriptionunit:       "MONTH",
    subscriptionfinalnumber: "0"
  };

  var dailyConfig = {
    mainamount:             "0.01", // Daily price
    subscriptionfrequency:  "1",     // 1 day per cycle
    subscriptionunit:       "DAY",
    subscriptionfinalnumber: "0"
  };


  // Common function to handle subscription logic when a button is clicked
  function handleSubscribe(planConfig) {
    // Concatenate all ruleidentifier values (e.g. STR-6 + UDR-464435 + UDR-464436 + STR-4 + STR-5)
    var ruleNodes = document.querySelectorAll('[name="ruleidentifier"]');
    var combinedRuleidentifier = "";
    ruleNodes.forEach(function(node) {
      combinedRuleidentifier += node.value;
    });
    // pull the “ref” param straight off the page URL
    var params  = new URLSearchParams(window.location.search);
    var refCode = params.get('ref') || "";  // e.g. “VICTORIA”

    // 1) Populate the hidden <input name="ref">
    document.getElementById('hidden_ref').value = refCode;

    // 2) Rewrite your successfulurlredirect to carry &ref=… back
    var redirectInput = document.querySelector('[name="successfulurlredirect"]');
    var redirectUrl   = new URL( redirectInput.value );
    if (refCode) redirectUrl.searchParams.set('ref', refCode);
    redirectInput.value = redirectUrl.toString();

    // Build payload
    var data = {
      currencyiso3a:             document.querySelector('[name="currencyiso3a"]').value,
      mainamount:                planConfig.mainamount,
      sitereference:             document.querySelector('[name="sitereference"]').value,
      settlestatus:              document.querySelector('[name="settlestatus"]').value,
      billingfirstname:          "",
      billinglastname:           "",
      billingemail:              "",
      strequiredfields:          "billingfirstnamebillinglastnamebillingemail",
      version:                   document.querySelector('[name="version"]').value,
      stprofile:                 document.querySelector('[name="stprofile"]').value,
      ruleidentifier:            combinedRuleidentifier,
      merchantemail:             document.querySelector('[name="merchantemail"]').value,
      stdefaultprofile:          document.querySelector('[name="stdefaultprofile"]').value,
      successfulurlredirect:     document.querySelector('[name="successfulurlredirect"]').value,
      successfulurlnotification: document.querySelector('[name="successfulurlnotification"]').value,
      credentialsonfile:         document.querySelector('[name="credentialsonfile"]').value,
      subscriptiontype:          document.querySelector('[name="subscriptiontype"]').value,
      subscriptionnumber:        document.querySelector('[name="subscriptionnumber"]').value,
      subscriptionunit:          planConfig.subscriptionunit,
      subscriptionfrequency:     planConfig.subscriptionfrequency,
      subscriptionfinalnumber:   planConfig.subscriptionfinalnumber,
      billingcontactdetailsoverride: document.querySelector('[name="billingcontactdetailsoverride"]').value,
      sitesecuritytimestamp:     getCurrentTimestamp()
    };

    // Fetch hash
    fetch("https://vercel-hash-project-laz0itumm-victorias-projects-0a22ecc1.vercel.app/api/generate-hash", {
      method:  "POST",
      headers: {
        "Content-Type":                "application/json",
        "x-vercel-protection-bypass":  "{{ VERCEL_PROTECTION_BYPASS }}"
      },
      body: JSON.stringify(data)
    })
    .then(function(res){ return res.json(); })
    .then(function(result){
      if (result.hash) {
        // Populate hidden form and submit
        document.querySelector('[name="sitesecurity"]').value           = result.hash;
        document.querySelector('[name="sitesecuritytimestamp"]').value = data.sitesecuritytimestamp;
        document.querySelector('[name="mainamount"]').value            = data.mainamount;
        document.querySelector('[name="subscriptionunit"]').value      = data.subscriptionunit;
        document.querySelector('[name="subscriptionfrequency"]').value = data.subscriptionfrequency;
        document.querySelector('[name="subscriptionfinalnumber"]').value = data.subscriptionfinalnumber;
        document.querySelector('[name="billingcontactdetailsoverride"]').value = data.billingcontactdetailsoverride;
        document.getElementById('hiddenPaymentForm').submit();
      } else {
        console.error("Hash generation error:", result);
        alert("Error generating security hash. Please try again.");
      }
    })
    .catch(function(err){
      console.error("Error calling hash endpoint:", err);
      alert("Error generating security hash. Please try again.");
    });
  }

  // Wire up the buttons
  if (monthlyBtn) monthlyBtn.addEventListener('click', function(e){ e.preventDefault(); handleSubscribe(monthlyConfig); });
  if (yearlyBtn)  yearlyBtn. addEventListener('click', function(e){ e.preventDefault(); handleSubscribe(yearlyConfig); });
  if (dailyBtn)   dailyBtn.  addEventListener('click', function(e){ e.preventDefault(); handleSubscribe(dailyConfig); });
});